export const CustomSelectStyle = {
    control: (base, state) => ({
        ...base,
        backgroundColor: 'var(--cell-background)',
        color: 'var(--cell-color)',
        borderColor: state.isFocused ? 'var(--accent)' : 'var(--accent)',
        boxShadow: 'none',
        '&:hover': {
            borderColor: 'var(--accent)',
        }
    }),
    menu: (base) => ({
        ...base,
        backgroundColor: 'var(--part-background)',
        color: 'var(--cell-color)',
    }),
    multiValue: (base) => ({
        ...base,
        backgroundColor: 'var(--accent)',
        color: '#fff',
    }),
    multiValueLabel: (base) => ({
        ...base,
        color: '#fff',
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? 'var(--accent)' : 'var(--part-background)',
        color: 'var(--cell-color)',
        '&:hover': {
            backgroundColor: 'var(--accent)',
            color: '#fff',
        }
    }),
    placeholder: (base) => ({
        ...base,
        color: 'var(--cell-color)',
    }),
    input: (base) => ({
        ...base,
        color: 'var(--cell-color)',
    }),
};
export const textFieldSlotProps = {
    textField: {
        sx: {
            height: 30,
            '& .MuiInputBase-root': {
                height: 30,
                color: 'var(--cell-color)',
                fontSize: '14px',
            },
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: 'var(--cell-color)',
                },
                '&:hover fieldset': {
                    borderColor: 'var(--cell-color)',
                },
                '&.Mui-focused fieldset': {
                    borderColor: 'var(--cell-color)',
                },
            },
            '& .MuiInputLabel-root': {
                color: 'var(--cell-color)',
                fontSize: '12px',
            },
            '& .MuiInputLabel-root.Mui-focused': {
                color: 'var(--cell-color)',
            },
            '& .MuiSvgIcon-root': {
                fontSize: '18px',
                color: 'var(--cell-color)',
            }
        },
        InputProps: {
            sx: {
                height: 30,
            }
        }
    }
};